<template>
    <button class="uik-btn__base uik-dropdown-item__wrapper" type="button" @click="$emit('close')">
        <span class="uik-btn__content">
            <slot></slot>
        </span>
    </button>
</template>

<script>
export default {
    name: "UikDropdownItem"
}
</script>
